<div class="deleteLinkDialog">
    <sync-dialog [config]="{
        title: 'Delete link',
        subTitle: fileName,
        isClosable: false,
        actionButton: 'Delete',
        cancelButton: 'Cancel',
        onActionClick: delete,
        onCancelClick: closeDeleteLinkDialog,
        isButtonLoading: isButtonLoading,
    }" [open]="showDeleteLinkDialog" [isFullScreen]="false" [onClose]="closeDeleteLinkDialog" [isCritical]="true">
    <div class="link-delete-container">
        <div class="remove-text">
            <div class="body-bold-1 delete-title">Are you sure you want to delete this link?</div>
            <div class="body-1">Your file will remain on Sync, but the link will no longer work.</div>
          </div>
    </div>
    </sync-dialog>
</div>
